
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Title extends Vue {
  @Prop({ default: 0 }) public step!: number;

  public getStepTitle(step: number) {
    let text = ''
    if (step == 1) {
      text = "1.基本情報の登録";
    } else if (step == 2) {
      text = "2.プロダクト・サービスの情報"
    } else if (step == 3) {
      text = "3.資金調達計画の登録"
    }
    return text;
  }
}
